import { InputHTMLAttributes, forwardRef } from 'react'

export interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, className = '', id, ...props }, ref) => {
    const inputId = id || `checkbox-${Math.random().toString(36).substr(2, 9)}`

    return (
      <div className="inline-flex items-center gap-2">
        <input
          ref={ref}
          type="checkbox"
          id={inputId}
          className={`w-[18px] h-[18px] cursor-pointer focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-background ${className}`}
          aria-label={label || props['aria-label']}
          {...props}
        />
        {label && (
          <label
            htmlFor={inputId}
            className="text-text-muted text-sm cursor-pointer"
          >
            {label}
          </label>
        )}
      </div>
    )
  }
)

Checkbox.displayName = 'Checkbox'
